export const text = {
  welcome: 'Welcome to HarvestMate',
  subtitle: 'Plan your gardens, browse plants, and stay organised through the season.',
  hubIntro: 'Browse the plant catalog, create a garden layout, or adjust your account in settings.',
  openGardens: 'Gardens',
  openGardensHint: 'Create and manage your garden layouts',
  openPlants: 'Plants',
  openPlantsHint: 'Browse the catalog and add your own plants',
  openSettings: 'Settings',
  openSettingsHint: 'Account, theme, and preferences',
};
